import { Link } from 'react-router-dom';
import { AdminNote } from '../../types/types';
import { formatDate } from '../../utils/utils';

interface NoteRowProps {
  note: AdminNote;
}

export const NoteRow = ({ note }: NoteRowProps) => {
  const linkTo = `/admin/note/${note.note_id}`;
  const linkClassName = 'block w-full h-full cursor-pointer';

  const cellData = [
    note.note_id,
    note.status,
    note.issuing_user,
    formatDate(note.time_uploaded),
    note.has_feedback ? 'True' : '',
  ];

  return (
    <tr className={`hover:bg-blue-100`}>
      {cellData.map((content, index) => (
        <td key={index} className="px-4 py-2 border-2 border-gray-400">
          <Link to={linkTo} className={linkClassName}>
            {content}
          </Link>
        </td>
      ))}
    </tr>
  );
};
